import { ProgressLinear } from '@americanexpress/dls-react';
import React from 'react';

const Loading = () => (
  <ProgressLinear className="flex flex-justify-center margin-left-10 margin-right-10" />
);

export default Loading;
